<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import UserEditModal from "./UserEditModal.svelte";


    let users = null;
    let userId = 0;
    let editUserId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: 'email', title: 'EMAIL', sortable: true, class: 'hidden-xs'},
        {key: 'login_at', title: 'ΕΙΣΟΔΟΣ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            users = result;
            users.map(item => {
                item.login_at = formatDate(item.login_at, 'y-m-d');
            });
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, {}, onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail}) => {
        users = sort(users, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editUserId = 0;
    }

    const onEdit = (user) => {
        userId = user.id;
        editUserId = user.id;
    }

    const closeEdit = (user) => {
        if (user) {
            let properties = ['id', 'name', 'email', 'login_at'];

            let item = users.find(x => x.id == user.id);
            if (item) {
                copyObjectProperties(user, item, properties);
                users = users;
            } else {
                users = [copyObjectProperties(user, properties), ...users];
            }
        }
        editUserId = null;
    }

    const onDelete = (user) => {
        Alert.delete("Διαγραφή χρήστη", `Να διαγραφεί μόνιμα ο χρήστης "${user.name}";`, () => deleteUser(user.id));
    }

    const deleteUser = id => {
        const onSuccess = result => {
            users = users.filter(x => x.id != result);
            Notifier.showMessage("Ο χρήστης διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                Alert.warning("Διαγραφή χρήστη", `Δεν είναι δυνατή η διαγραφή αυτού του χρήστη!`);
                return;
            }

            if (err.code === 'object_related') {
                let message = [];
                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });
                Alert.warning("Διαγραφή χρήστη", `Ο χρήστης σχετίζεται με ${message.join(", ")}.\nΔεν είναι δυνατή η διαγραφή του.`);
            }
        };

        R.handle(R.user.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();

    // $: if (users) {
    //     users.map(item => {
    //         item.roles = [];
    //         if (item.is_admin == 1) {
    //             item.roles.push("Διαχειριστής");
    //         }
    //         if (item.is_driver == 1) {
    //             item.roles.push("Οδηγός");
    //         }
    //     })
    // }
</script>

<PageHeader title="Χρήστες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if users}
    <div class="panel">
        <div class="panel-body">
            {#if users.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each users as item}
                        <tr class="row-hover" class:row-selected="{ userId === item.id }">
                            <td>
                                <span class="is-link" class:not-active="{ item.is_active < 1 }"
                                      on:click="{ () => onEdit(item) }">
                                    { item.name }
                                </span>
                                {#if item.email}
                                    <div class="hidden-xl hidden-lg hidden-md hidden-sm text-gray">
                                        <a href="mailto:{ item.email }">{ item.email }</a>
                                    </div>
                                {/if}
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.email }
                            </td>
                            <td class="text-gray date-column hidden-xs">
                                { formatDate(item.login_at, 'd-m-y') }
                            </td>
                            <td class="button-column">
                                <button class="button" title="διαγραφή" on:click={ () => onDelete(item) }>
                                    <AppIcon icon="trash" size="16"/>
                                </button>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
{/if}
{#if editUserId != null}
    <UserEditModal userId="{ editUserId }" closeCallback="{ closeEdit }"/>
{/if}